import { configureStore } from "@reduxjs/toolkit";
import bookingReducer from "../reducer/bookingSlice";

const store = configureStore({
  reducer: {
    booking: bookingReducer,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;

export default store;
